// Native Base Default Theme 헬퍼

// =================================================================================================
// 가져오기
// =================================================================================================
// 고정 영역

// 동적 영역
import {
  extendTheme, // 테마 확장
} from 'native-base';
import nativeBaseDefaultTheme from './nativeBaseDefaultTheme';

// =================================================================================================
// 상수
// =================================================================================================
// 네이티브베이스 앱 확장 테마 - 기본
const nativeBaseBasicAppExtendTheme = extendTheme({
  colors: {
    // 크림
    cream500: '#FBFDEF', // [크림]

    //  크림 핑크
    creamPink500: '#FAC7CF', // [크림 핑크]

    // 핫

    //  핫 핑크
    hotPink500: '#F565A6', // [핫 핑크]

    //  핫 레드
    hotRed500: '#FF3434', // [핫 레드]

    // 마일드

    //  마일드 블랙
    mildBlack500: '#313131', // [마일드 블랙]

    // //  primary
    // primary50: 'primary.50', // #ecfeff [흰 파스텔파란색] [name + Design token]
    // primary100: 'primary.100', // #cffafe
    // primary200: 'primary.200', // #a5f3fc
    // primary300: 'primary.300', // #67e8f9
    // primary400: 'primary.400', // #22d3ee
    // primary500: 'primary.500', // #06b6d4 [파스텔파란색]
    // primary600: 'primary.600', // #0891b2
    // primary700: 'primary.700', // #0e7490
    // primary800: 'primary.800', // #155e75
    // primary900: 'primary.900', // #164e63 [흑 파스텔파란색]
    // //  secondary
    // secondary50: 'secondary.50', // #fdf2f8 [흰 파스텔핑크]
    // secondary100: 'secondary.100', // #fce7f3
    // secondary200: 'secondary.200', // #fbcfe8
    // secondary300: 'secondary.300', // #f9a8d4
    // secondary400: 'secondary.400', // #f472b6
    // secondary500: 'secondary.500', // #ec4899 [파스텔핑크]
    // secondary600: 'secondary.600', // #db2777
    // secondary700: 'secondary.700', // #be185d
    // secondary800: 'secondary.800', // #9d174d
    // secondary900: 'secondary.900', // #831843 [흑 파스텔핑크]
    // //  tertiary
    // tertiary50: 'tertiary.50', // # [흰 파스텔녹색]
    // tertiary100: 'tertiary.100', // #
    // tertiary200: 'tertiary.200', // #
    // tertiary300: 'tertiary.300', // #
    // tertiary400: 'tertiary.400', // #
    // tertiary500: 'tertiary.500', // # [파스텔녹색]
    // tertiary600: 'tertiary.600', // #
    // tertiary700: 'tertiary.700', // #
    // tertiary800: 'tertiary.800', // #
    // tertiary900: 'tertiary.900', // # [흑 파스텔녹색]
    // //  danger
    // danger50: 'danger.50', // # [흰 진핑크]
    // danger100: 'danger.100', // #
    // danger200: 'danger.200', // #
    // danger300: 'danger.300', // #
    // danger400: 'danger.400', // #
    // danger500: 'danger.500', // # [진핑크]
    // danger600: 'danger.600', // #
    // danger700: 'danger.700', // #
    // danger800: 'danger.800', // #
    // danger900: 'danger.900', // # [흑 진핑크]
    // //  error
    // error50: 'error.50', // # [흰 진주황]
    // error100: 'error.100', // #
    // error200: 'error.200', // #
    // error300: 'error.300', // #
    // error400: 'error.400', // #
    // error500: 'error.500', // # [진주황]
    // error600: 'error.600', // #
    // error700: 'error.700', // #
    // error800: 'error.800', // #
    // error900: 'error.900', // # [흑 진주황]
    // //  success
    // success50: 'success.50', // # [흰 초록]
    // success100: 'success.100', // #
    // success200: 'success.200', // #
    // success300: 'success.300', // #
    // success400: 'success.400', // #
    // success500: 'success.500', // # [초록]
    // success600: 'success.600', // #
    // success700: 'success.700', // #
    // success800: 'success.800', // #
    // success900: 'success.900', // # [흑 초록]
    // //  warning
    // warning50: 'warning.50', // # [흰 주황]
    // warning100: 'warning.100', // #
    // warning200: 'warning.200', // #
    // warning300: 'warning.300', // #
    // warning400: 'warning.400', // #
    // warning500: 'warning.500', // # [주황]
    // warning600: 'warning.600', // #
    // warning700: 'warning.700', // #
    // warning800: 'warning.800', // #
    // warning900: 'warning.900', // # [흑 주황]
    // //  muted
    // //  info
    // //  light
    // //  singletons
    // //  rose
    // //  pink
    // //  fuchsia
    // //  purple
    // //  violet
    // //  indigo
    // //  blue
    // //  lightBlue
    // //  darkBlue
    // //  cyan
    // //  teal
    // //  emerald
    // //  green
    // //  lime
    // //  yellow
    // //  amber
    // //  orange
    // //  amber
    // //  red
    // //  warmGray
    // //  trueGray
    // //  gray
    // //  coolGray
    // //  blueGray
    // //  dark
  },
  fontSizes: {
    // '2xs': 10,
    // xs: 12,
    // sm: 14,
    // md: 16,
    // lg: 18,
    // xl: 20,
    // '2xl': 24,
    // '3xl': 30,
    // '4xl': 36,
    // '5xl': 48,
    // '6xl': 60,
    // '7xl': 72,
    // '8xl': 96,
    // '9xl': 128,
  },
  // Make sure values below matches any of the keys in `fontConfig`
  fonts: {
    // heading: 'Roboto',
    // body: 'Roboto',
    // mono: 'Roboto',
  },
  config: {},

  fontConfig: {
    // Roboto: {
    //   100: {
    //     normal: 'Roboto-Light',
    //     italic: 'Roboto-LightItalic',
    //   },
    //   200: {
    //     normal: 'Roboto-Light',
    //     italic: 'Roboto-LightItalic',
    //   },
    //   300: {
    //     normal: 'Roboto-Light',
    //     italic: 'Roboto-LightItalic',
    //   },
    //   400: {
    //     normal: 'Roboto-Regular',
    //     italic: 'Roboto-Italic',
    //   },
    //   500: {
    //     normal: 'Roboto-Medium',
    //   },
    //   600: {
    //     normal: 'Roboto-Medium',
    //     italic: 'Roboto-MediumItalic',
    //   },
    //   // Add more variants
    //   //   700: {
    //   //     normal: 'Roboto-Bold',
    //   //   },
    //   //   800: {
    //   //     normal: 'Roboto-Bold',
    //   //     italic: 'Roboto-BoldItalic',
    //   //   },
    //   //   900: {
    //   //     normal: 'Roboto-Bold',
    //   //     italic: 'Roboto-BoldItalic',
    //   //   },
    // },
  },

  components: {
    // Button: {
    //   // Can simply pass default props to change default behaviour of components.
    //   baseStyle: {
    //     rounded: 'md',
    //   },
    //   defaultProps: {
    //     colorScheme: 'red',
    //   },
    //   variants: {
    //     rounded: ({ colorScheme }) => {
    //       return {
    //         bg: `${colorScheme}.500`, // Adding Variants
    //         rounded: 'full',
    //       };
    //     },
    //   },
    // },
    // Heading: {
    //   // Can pass also function, giving you access theming tools
    //   baseStyle: ({ colorMode }) => {
    //     return {
    //       color: colorMode === 'dark' ? 'red.300' : 'blue.300',
    //       fontWeight: 'normal',
    //     };
    //   },
    // },
    // Text: {
    //   baseStyle: {
    //     // Customizing Base Style
    //     color: 'emerald.400',
    //   },
    //   defaultProps: {
    //     size: 'lg',
    //   },
    //   sizes: {
    //     xl: {
    //       fontSize: '64px',
    //     },
    //     lg: {
    //       fontSize: '32px',
    //     },
    //     md: {
    //       fontSize: '16px',
    //     },
    //     sm: {
    //       fontSize: '12px',
    //     },
    //   },
    // },
  },

  //  letterSpacings
  letterSpacings: {
    '2xs': nativeBaseDefaultTheme.fontSizes['2xs'],
  },
});

// =================================================================================================
// 내보내기
// =================================================================================================
export default nativeBaseBasicAppExtendTheme;
